import React from 'react';
import dayjs, { Dayjs } from 'dayjs';
import { useRouter } from 'next/router';
import { AvailabilityClosestWrapper } from '@maiia/model/generated/model/api-patient/api-patient';
import { Card } from '@maiia/design-system';
import Link from '../../atoms/Link/Link';
import { dayjsWithTimezone } from '@/src/utils';
import { DEFAULT_TIMEZONE } from '@/src/constants';
import FirstAvailabilityMobile from '@/components/organisms/ProfileContent/FirstAvailabilityMobile';

type AvailabilityMobileProps = {
  closestAvailabilities: AvailabilityClosestWrapper;
  timezone: string | undefined;
};

const AvailabilityMobile = ({
  closestAvailabilities,
  timezone,
}: AvailabilityMobileProps) => {
  const router = useRouter();
  const dayjsTZ = dayjsWithTimezone(timezone || DEFAULT_TIMEZONE);
  const {
    closestPhysicalAvailability,
    closestTeleconsultationAvailability,
  } = closestAvailabilities;

  let closestDate: Dayjs | undefined;

  if (closestPhysicalAvailability && closestTeleconsultationAvailability) {
    closestDate = dayjs.min(
      dayjsTZ(closestPhysicalAvailability.startDateTime),
      dayjsTZ(closestTeleconsultationAvailability.startDateTime),
    );
  } else if (closestPhysicalAvailability) {
    closestDate = dayjsTZ(closestPhysicalAvailability.startDateTime);
  } else if (closestTeleconsultationAvailability) {
    closestDate = dayjsTZ(closestTeleconsultationAvailability.startDateTime);
  }

  if (!closestDate) return null;

  return (
    <Card hasOldStyle className="killondesk">
      <Link
        href={{
          pathname: `${router.pathname}/rdv`,
          query: router.query,
        }}
        legacyBehavior
      >
        <FirstAvailabilityMobile closestDate={closestDate} />
      </Link>
    </Card>
  );
};

export default AvailabilityMobile;
